




















































import { Vue, Prop, Component } from "vue-property-decorator";
import {
  NotificationSettingsTypes,
  translateNotificationType
} from "@/services/notifications";
import { CompanySettings as ICompanySettings } from "@/api-v2/notification/models/company-settings";
import { Tokens as ITokens } from "@/api-v2/notification/models/tokens";
import { Token as IToken } from "@/api-v2/notification/models/token";

@Component
export default class CompanyNotificationForm extends Vue {
  @Prop() settings?: ICompanySettings;
  @Prop() type!: NotificationSettingsTypes;
  @Prop() tokens!: ITokens;
  isOpened: boolean = false;

  get label() {
    return translateNotificationType(this.type);
  }

  get form() {
    return this.settings;
  }

  set form(value) {
    this.$emit("update:settings", value);
  }

  get tokenList(): IToken[] {
    const tokensMap = new Map(Object.entries(this.tokens));

    return tokensMap.get(this.type);
  }

  formattedToken(token: string) {
    return `{{ ${token} }}`;
  }

  copyToken(token: string) {
    navigator.clipboard.writeText(`{{ ${token} }}`);
  }
}
